export default "__VITE_ASSET__7Di5F9dw__"